import { defaultLocale } from "@faro-lotv/foundation";
import { DateTime, type DateTimeFormatOptions } from "luxon";

export const MONTH_AND_YEAR: DateTimeFormatOptions = {
  month: "long",
  year: "numeric",
};
export const DAY_AND_MONTH: DateTimeFormatOptions = {
  day: "numeric",
  month: "short",
};

/**
 * @returns The date formatted for the user's locale, following the locale the foundation
 * package uses for the other dates of the app
 * @param date The date to format
 * @param format The parts of the date to show; defaults to the day, short month and year
 */
export function formatDate(
  date: DateTime | Date,
  format: DateTimeFormatOptions = DateTime.DATE_MED,
): string {
  const dateTime = date instanceof Date ? DateTime.fromJSDate(date) : date;
  return dateTime.toLocaleString(format, { locale: defaultLocale });
}
